import React, {useRef} from 'react';
import {View, Modal, Platform} from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import {BUTTON_TYPES} from '../../../utils/Constants';
import {DLog} from '../../../utils/HelperMethods';
import CalendarView from '../../elements/CalendarView';
import Divider from '../../elements/Divider';
import Button from '../../elements/Button';
import makeStyles from './styles';
import {useTheme, useThemedStyles} from '../../../theme';

const BloodSugarCalendar = ({visible, onClose}) => {
  const {colors} = useTheme();
  const styles = useThemedStyles(makeStyles);
  const selectedDateRange = useRef(null);

  const onSelectDateRange = (fromDate, toDate) => {
    selectedDateRange.current = {fromDate, toDate};
    DLog(selectedDateRange.current);
  };

  return (
    <Modal
      transparent
      visible={visible}
      animationType="slide"
      onRequestClose={() => onClose(false)}>
      <View
        style={[
          styles.container,
          Platform.OS === 'web' && styles.webContainer,
        ]}>
        <SafeAreaView
          style={[
            styles.safeareaContainer,
            Platform.OS === 'web' && styles.detailsContainer,
          ]}>
          <View style={styles.bottomContainer}>
            <View>
              <CalendarView disabled={false} onSelectDate={onSelectDateRange} />
            </View>
            <Divider top={16} />
            <View style={styles.buttonsContainer}>
              <Button
                style={[styles.button]}
                buttonType={BUTTON_TYPES.Bordered}
                title={'Cancel'}
                onPress={() => onClose(false)}
              />
              <Button
                style={[styles.button, styles.ml16]}
                buttonType={BUTTON_TYPES.Filled}
                titleColor={colors.textOnAccent}
                title={'Confirm'}
                onPress={() => onClose(selectedDateRange.current)}
              />
            </View>
          </View>
        </SafeAreaView>
      </View>
    </Modal>
  );
};

export default BloodSugarCalendar;
